import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ReviewPeriodEnum } from "@altertec_gparn/lib";
import { QuestionDto } from "@/core/features/questions/question.dto";
import { Type } from "class-transformer";

const PERIODIC_REVIEW_PERIODS: readonly ReviewPeriodEnum[] = [
  ReviewPeriodEnum.ONE_MONTH,
  ReviewPeriodEnum.THREE_MONTHS,
] as const;

export class ChecklistDto extends BaseEntityDto {
  reviewPeriod: ReviewPeriodEnum;

  includeIncidentSection: boolean;

  includeObservationSection: boolean;

  includeDocumentationSection: boolean;

  includeEquipmentSection: boolean;

  isActive: boolean;

  @Type(() => QuestionDto)
  questions: QuestionDto[];

  hasPeriodicReview(): boolean {
    return PERIODIC_REVIEW_PERIODS.includes(this.reviewPeriod);
  }
}
